import { addNavMenuSection } from '@vendure/admin-ui/core';
import { Permission } from './generated-types';

export default [
  addNavMenuSection({
    id: 'hr-solutions',
    label: 'HR Solutions',
    requiresPermission: Permission.ReadJobs,
    items: [
      {
        id: 'jobs',
        label: 'Job',
        routerLink: ['/extensions/jobs/vacancies'],
        icon: 'employee',
        requiresPermission: Permission.ReadJobs
      },
      {
        id: 'jobs',
        label: 'Employer Requests',
        routerLink: ['/extensions/jobs/job-requests'],
        icon: 'event',
        requiresPermission: Permission.ReadJobRequests
      }
    ]
  })
];
